module.exports = __webpack_public_path__ + "static/media/ZUP65.86c2b923.pdf";